import React, {useEffect, useMemo, useRef, useState} from "react";

import styles from "./VideoPlayer2.module.css";
import "./videoConfig.css";

// import Plyr from "plyr-react";
// import "plyr-react/plyr.css";
import Mobile, { fullScreenHandler } from "../Mobile/Mobile";
import "fluid-player/src/css/fluidplayer.css";
import fluidPlayer from 'fluid-player'
import {I_TechItemPart} from "../../../../Models/interfaces";

type xProps = {
  videoSrc: string;
  userNumber: string;
  currDataIndex: number;
  teachData?: I_TechItemPart;
  onVideoSelected: () => void;
  setCurrDataIndex: React.Dispatch<React.SetStateAction<number>>;
};

const VideoPlayer2: React.FunctionComponent<xProps> = ({
  videoSrc,
  userNumber,
  currDataIndex,
  teachData,
  onVideoSelected,
  setCurrDataIndex,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const self = useRef<HTMLVideoElement>(null);
  const [player,setPlayer] = useState<FluidPlayerInstance|null>(null);
  const [videoHtml,setVideoHtml] = useState(<video ref={self}>
      <source src={videoSrc}
              data-fluid-hd
              title='1080p'
              type='video/mp4'/>
  </video>);

    useEffect(() => {

        if(player) {
            setVideoHtml(<video ref={self}>
                <source src={videoSrc}
                        data-fluid-hd
                        title='1080p'
                        type='video/mp4'/>
            </video>);
            if(self.current){
                self.current.load();
                self.current.play();
            }

            // player.destroy();
        }else{
            if(self.current){
                setPlayer(fluidPlayer(self.current, {
                        layoutControls: {
                            preload: 'auto',
                            fillToContainer: false, // Default true
                            doubleclickFullscreen: false, // Default true
                            subtitlesEnabled: false,
                            keyboardControl: true,
                            playButtonShowing: true,
                            playPauseAnimation: true,
                            layout: 'default',
                            playbackRateEnabled: true,
                            persistentSettings: {
                                volume: true, // Default true
                                quality: false, // Default true
                                speed: true, // Default true
                                theatre: false // Default true
                            },
                            allowTheatre: false,
                            autoPlay : true,
                            primaryColor:"blueviolet",
                            miniPlayer:{
                                enabled:false
                            }
                        },
                    }
                ));
            }
        }

    },[videoSrc]);

    useEffect(() => {
        if(player){
            player.on('ended', () => {
                if(currDataIndex < Number(teachData?.data.length) - 1){
                    setCurrDataIndex((prevState) => {
                        if (prevState === Number(teachData?.data.length) - 1) {
                            return prevState;
                        }
                        return prevState + 1;
                    });
                    onVideoSelected();
                }
            });
        }
    },[player]);

  return (
    <div
      className={`${styles.videoPlayer2Contianer}`}
      ref={containerRef}
      onClick={() => {}}
      onDoubleClick={() => {
        //fullScreenHandler(containerRef);
      }}
    >
      {videoHtml}
      <Mobile mobileNumber={userNumber} />
    </div>
  );
};

export default VideoPlayer2;
